"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var ComponentVerticalSpacing = function ComponentVerticalSpacing(_ref) {
  var children = _ref.children,
    noTop = _ref.noTop,
    noBottom = _ref.noBottom,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(className, !noTop && 'margin-top-xl', !noBottom && 'margin-bottom-xl')
  }, children);
};
ComponentVerticalSpacing.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].func]).isRequired,
  noTop: _propTypes["default"].bool,
  noBottom: _propTypes["default"].bool,
  className: _propTypes["default"].string
};
var _default = exports["default"] = ComponentVerticalSpacing;